var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgPencil(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M5.431 16.922a4.31 4.31 0 01.657-1.313v-.046h.047c.093-.141.234-.282.328-.376L20.713.938a3.027 3.027 0 014.265 0l1.828 1.829c.141.14.282.328.375.468a2.99 2.99 0 01-.375 3.797l-14.25 14.25c-.046.047-.14.094-.187.188-.047.047-.14.093-.188.14v.047h-.046a4.31 4.31 0 01-1.313.657L7.166 23.39 5.15 24c-.375.094-.797 0-1.078-.328a.956.956 0 01-.281-1.078l.562-2.016 1.078-3.656zm16.266-7.969l-2.906-2.906-8.719 8.719.563 2.343 2.343.563 8.72-8.719zM8.291 16.828l-.563.375a3.235 3.235 0 00-.14.375l-.328 1.078-.75 2.578 2.578-.75 1.078-.328a3.21 3.21 0 00.375-.14l.375-.516-1.453-.375a1.11 1.11 0 01-.844-.844l-.328-1.453zm10.219-6.562l-4.5 4.5c-.282.28-.797.28-1.079 0a.736.736 0 010-1.032l4.5-4.5a.714.714 0 011.079 0 .736.736 0 010 1.032z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgPencil);
export default ForwardRef;
